var createInitialProfileFormState = function (profileInfo) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var phoneNumbers = {
        mobile: "",
        home: "",
        business: "",
    };
    profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.phone.forEach(function (phoneItem) {
        var _a;
        var key = phoneItem.contactType.toLowerCase();
        phoneNumbers[key] = (_a = phoneItem === null || phoneItem === void 0 ? void 0 : phoneItem["cipher.contactNumber"]) !== null && _a !== void 0 ? _a : "";
    });
    return {
        phoneNumbers: phoneNumbers,
        mailingAddress: {
            street1: (_a = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.mailingAddress["cipher.addressLine1"]) !== null && _a !== void 0 ? _a : "",
            street2: (_c = (_b = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.mailingAddress) === null || _b === void 0 ? void 0 : _b["cipher.addressLine2"]) !== null && _c !== void 0 ? _c : "",
            city: (_d = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.mailingAddress["cipher.city"]) !== null && _d !== void 0 ? _d : "",
            state: (_e = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.mailingAddress["cipher.state"]) !== null && _e !== void 0 ? _e : "",
            zipCode: (_f = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.mailingAddress["cipher.zipCode"]) !== null && _f !== void 0 ? _f : "",
        },
        emailAddress: (_g = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo["cipher.email"]) !== null && _g !== void 0 ? _g : "",
        annualNetIncome: (_h = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo["cipher.annualNetIncome"]) !== null && _h !== void 0 ? _h : "",
    };
};
export default createInitialProfileFormState;
